<template>
  <div v-if="show" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
    <div class="relative w-full max-w-md max-h-full">
      <div class="relative bg-white rounded-lg shadow">
        <!-- Close Button -->
        <button
          type="button"
          @click="handleCancel"
          class="absolute top-3 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
        >
          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
          </svg>
          <span class="sr-only">Close modal</span>
        </button>

        <!-- Modal Content -->
        <div class="p-6 text-center">
          <h1 class="mb-5 text-lg font-bold dark:text-black">{{ $t('common.leavePage')  }}</h1>
          <h3 class="mb-5 text-lg font-semibold text-gray-500">{{ $t('common.changesWillNotBeSaved') }}</h3>

          <!-- Action Buttons -->
          <ActionButton @click="handleConfirm" color="red" :wfull="false" :margin="true">
            {{ $t('common.leave') }}
          </ActionButton>
          <ActionButton @click="handleCancel" :wfull="false" :margin="true">
            {{ $t('common.cancel') }}
          </ActionButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from './ActionButton.vue'

export default {
  name: "ConfirmLeaveModal",
  components: {ActionButton},
  props: {
    show: { type: Boolean, required: true },
    pendingNavigation: { type: Function, default: null },
  },
  emits: ["update:show"],
  methods: {
    handleConfirm() {
      this.$emit("update:show", false);
      if (this.pendingNavigation) this.pendingNavigation();
    },
    handleCancel() {
      this.$emit("update:show", false);
    }
  }
};
</script>